import firebase from 'firebase/app'
import { get } from 'lodash'
import roles from '../configs/roles'

export default async (to, from, next) => {
  const accessRoles = to.matched.reduce((acc, r) => {
    const routeRoles = Array.isArray(r.meta.accessRoles)
      ? r.meta.accessRoles
      : []

    return [ ...acc, ...routeRoles]
  }, [])

  const token = firebase.auth().currentUser
    ? await firebase.auth().currentUser.getIdTokenResult()
    : {}

  const role = get(token, 'claims.role')

  if (Array.isArray(accessRoles) && accessRoles.length > 0) {
    const hasRole = accessRoles.includes(role)
    const defaultRoute = role in roles
      ? roles[ role ].defaultRoute
      : { name: 'customers' } // fallback

    console.log(hasRole, defaultRoute, accessRoles)

    hasRole
      ? next()
      : next(defaultRoute)
  } else {
    next()
  }
};
